import { useTranslation } from 'react-i18next';
import { mdiSend } from '@mdi/js';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { formatDate } from 'common/utils/formatDate';
import { IBudgetRequestLogFragment } from 'graphql/types';
import {
    BUDGET_REQUEST_STATUS_CONFIG,
    PENDING_BUDGET_REQUEST_STATUSES,
} from 'budget/constants/budgetApprovals';
import {
    BudgetRequestTimeLine,
    BudgetRequestTimeLineStep,
} from 'budget/components/BudgetRequestTimeLine';

interface IProps {
    logs: IBudgetRequestLogFragment[];
    creationDate: string;
    requestedByName: string;
}

export const BudgetRequestLog = ({
    logs,
    creationDate,
    requestedByName,
}: IProps) => {
    const [translate] = useTranslation();

    const transKey = 'budgetRequestLog';

    return (
        <BudgetRequestTimeLine>
            <BudgetRequestTimeLineStep iconPath={mdiSend}>
                <Typography>
                    <Box component="span" sx={{ fontWeight: 'bold' }}>
                        {translate(`${transKey}.submitted`)}
                    </Box>{' '}
                    {translate(`${transKey}.by`, { name: requestedByName })}
                </Typography>

                <Typography
                    color="text.secondary"
                    component="div"
                    variant="caption"
                >
                    {formatDate(creationDate, "d MMMM yyyy 'om' HH:mm")}
                </Typography>
            </BudgetRequestTimeLineStep>

            {logs.map((log) => {
                const { iconPath, labelKey, timelineColor } =
                    BUDGET_REQUEST_STATUS_CONFIG[log.status];

                return (
                    <BudgetRequestTimeLineStep
                        color={timelineColor}
                        iconPath={iconPath}
                        key={log.id}
                    >
                        <Typography>
                            <Box component="span" sx={{ fontWeight: 'bold' }}>
                                {translate(labelKey)}
                            </Box>

                            {log.user &&
                                !PENDING_BUDGET_REQUEST_STATUSES.includes(
                                    log.status
                                ) && (
                                    <>
                                        {' '}
                                        {translate(`${transKey}.by`, {
                                            name: log.user.name,
                                        })}
                                    </>
                                )}
                        </Typography>

                        {!!log.reason && (
                            <Typography color="text.secondary" variant="body2">
                                {log.reason}
                            </Typography>
                        )}

                        {!PENDING_BUDGET_REQUEST_STATUSES.includes(
                            log.status
                        ) && (
                            <Typography
                                color="text.secondary"
                                component="div"
                                variant="caption"
                            >
                                {formatDate(
                                    log.creationDate,
                                    "d MMMM yyyy 'om' HH:mm"
                                )}
                            </Typography>
                        )}
                    </BudgetRequestTimeLineStep>
                );
            })}
        </BudgetRequestTimeLine>
    );
};
